import {Camera, vec3, FrameBuffer, Scene, Mesh, Program, Texture, GeometryBuffer, PlaneGeometryBuffer} from '../../beam/index';
import settings from "./settings";
import hexToRgbA from "./hexToRgbA";
import MeshSurfaceSampler from '../MeshSurfaceSampler';
import { debugData } from '../settings';
import LinePositionVS  from './line-position-vs.glsl';
import LinePositionFS  from './line-position-fs.glsl';
import LineVS  from './line-vs.glsl';
import LineFS  from './line-fs.glsl';

function setUniform(uniforms, name, value) {
    if (uniforms[name]) {
        uniforms[name].value = value
    }
}

let uniforms = {}

let hasRenderedOnce = false;
let colorProgess = 0;
let mode = 0;

let elapsed = 0;
let lastDate  = ( typeof performance === 'undefined' ? Date : performance ).now();
let renderer;

let LINE_START_COLORS = [
    hexToRgbA('#ff0000'),
    hexToRgbA('#00ff00'),
    hexToRgbA('#00ff00')
]
let LINE_END_COLORS = [
    hexToRgbA('#0000ff'),
    hexToRgbA('#ff0000'),
    hexToRgbA('#0000ff')
]
var LINE_BUFFER_SIZE      = [500,500]//settings.lineBufferSize;
var LINE_SEGMENTS         = 1;//settings.uSegments;
let clearColor            = [0,0,0];
let lightColor            = [ 253./255.,252./255.,248./255.]

let lineSimulationTexture,
targetTexture,
    linePositionFront,
    linePositionBack,
    linePositionRead,
    linePositionWrite,
    linePositionMaterial,
    lineMesh;

// function iSphere(rayOrigin, rayDirection, center, radius) {
//     let a = vec3.dot(rayDirection, rayDirection);
//     let  s0_rayOrigin = vec3.create();
//     vec3.subtract(s0_rayOrigin, rayOrigin, center)
//     let b = 2.0 * vec3.dot(rayDirection, s0_rayOrigin);
//     let c = vec3.dot(s0_rayOrigin, s0_rayOrigin) - (radius * radius);
//     if (b*b - 4.0*a*c < 0.0) {
//         return -1.0;
//     }
//     return (-b - Math.sqrt((b*b) - 4.0*a*c))/(2.0*a);
// }


let phi, costheta, theta;
let r = 1;
let speed = 0;
let data = []
let targetData = []

let lastLineIndex = -1
let normR = vec3.create();
let bufferScene  = new Scene();
bufferScene.uniforms  = uniforms;
let bufferCamera = new Camera({
    left:          -512/2,
    right:          512/2,
    top:            512/2,
    bottom:        -512/2,
    near:          1,
    far:           4000.0,
    type:          'ortho',
    orbitControl:  false,
    lookAt:        [0,0,0]
});
bufferCamera.position[2] = 1000;
bufferCamera.position[0] = 0.01;
bufferCamera.position[1] = 0.01;
bufferCamera.lookAt = vec3.create()

let bufferPlane = new Mesh();
bufferPlane.id = 'gpgpu-particles-bufferplane';
bufferPlane.name = 'gpgpu-particles-bufferplane';
// bufferPlane.static = true;

export default class ParticleSystem {

    constructor(rendererO, options) {

        this.options = options;

        renderer = rendererO;

        bufferPlane.geometry = new PlaneGeometryBuffer(renderer.gl, {
            width:  1, 
            height: 1
        });
        bufferScene.add(bufferPlane)

        if (options.meshes) {
            this.meshes = []
            options.meshes.forEach((mesh)=>{
                this.meshes.push({
                    color: mesh.color,
                    surfaceSampler: new MeshSurfaceSampler(mesh.positions)
                })
            })
        }

        for( var i = 0, l = LINE_BUFFER_SIZE[0] * LINE_BUFFER_SIZE[1]; i < l; i ++ ) {
            let lineIndex = Math.floor(i/(LINE_SEGMENTS));
            if (lineIndex !== lastLineIndex) {
                lastLineIndex = lineIndex;
                phi      = Math.random() * 2 * Math.PI;
                costheta = Math.random() * 2 -1;
                theta    = Math.acos( costheta );
                r        = (0.5+Math.random()*0.5)*200.
                speed    = Math.random();
            }

            if (this.meshes) {
                let randomMeshIndex = Math.floor( this.meshes.length * Math.random() )
                let mesh = this.meshes[ randomMeshIndex ]
                let p = mesh.surfaceSampler.sample()
                targetData[ i * 4 ]     = p[0]
                targetData[ i * 4 + 1 ] = p[1]
                targetData[ i * 4 + 2 ] = p[2]
                targetData[ i * 4 + 3 ] = Math.random()
            }

            data[ i * 4 ]     = targetData[ i * 4 + 0 ] + (Math.random() - 0.5) * 2 * 50;//r * Math.sin( theta) * Math.cos( phi );
            data[ i * 4 + 1 ] = targetData[ i * 4 + 1 ] * 10;//Math.abs(r * Math.sin( theta) * Math.sin( phi )) + 1.
            data[ i * 4 + 2 ] = targetData[ i * 4 + 2 ] + (Math.random() - 0.5) * 2 * 50;//r * Math.cos( theta );
            data[ i * 4 + 3 ] = Math.random();
        }

        lineSimulationTexture = new Texture( renderer.gl,{
            data:   this.options.profile==0 ? new Float32Array(targetData) : new Float32Array(data), 
            width:  LINE_BUFFER_SIZE[0], 
            height: LINE_BUFFER_SIZE[1], 
            type:   renderer.gl.FLOAT,
            linear: false
        });

        targetTexture = new Texture( renderer.gl,{
            data:   new Float32Array(targetData), 
            width:  LINE_BUFFER_SIZE[0], 
            height: LINE_BUFFER_SIZE[1], 
            type:   renderer.gl.FLOAT,
            linear: false
        });

        linePositionFront = new FrameBuffer(renderer.gl, {
            width:  LINE_BUFFER_SIZE[0],  
            height: LINE_BUFFER_SIZE[1], 
            linear: false, 
            type:   renderer.gl.FLOAT,
        });
        linePositionBack = new FrameBuffer(renderer.gl, {
            width:  LINE_BUFFER_SIZE[0], 
            height: LINE_BUFFER_SIZE[1], 
            linear: false, 
            type:   renderer.gl.FLOAT,
        });
        linePositionRead     = lineSimulationTexture;
        linePositionWrite    = linePositionFront;
        linePositionMaterial = new Program(renderer.gl,{
            vertexShader:   LinePositionVS,
            fragmentShader: LinePositionFS,
            depthTest: false,
            blend: false,
        });
        linePositionMaterial.name = 'linePositionMaterial'

        
        let vertices = []
        let normals  = []
        let colors = []
        let uvs = []
        let textWidth  = LINE_BUFFER_SIZE[0]
        let textHeight = LINE_BUFFER_SIZE[1]
        let numLines =  (textWidth*textHeight)/LINE_SEGMENTS;

        let lineIndices     = [];
        let lineSpeeds      = [];
        let segmentIndices  = [];
        let verticeIndices   = [];
        for (let i=0; i<numLines; i++) {
            let rand = Math.random()
            for (let j = 0; j<LINE_SEGMENTS; j++) {
                for (let k=0;k<2; k++) {
                    let pos = [ Math.random(), Math.random(), Math.random() ]
                    vertices.push( pos[0],pos[1],pos[2] );
                    uvs.push( 0, 1 );
                    lineSpeeds.push(rand);
                    normals.push( 0,1,0 );
                    lineIndices.push(i);
                    segmentIndices.push(j)
                    verticeIndices.push(k)
                    if (options.color) {
                        colors.push( options.color[0], options.color[1], options.color[2] )
                    }
                    else {
                        colors.push( Math.random(), Math.random(), Math.random() )
                    }
                }
            }
        }
        lineMesh = new Mesh();
        lineMesh.id = 'lineMesh'
        lineMesh.name = 'lineMesh'
        lineMesh.geometry = new GeometryBuffer(renderer.gl, vertices.length/3)
        lineMesh.geometry.addAttribute( 'position', new Float32Array( vertices ), 3 );
        lineMesh.geometry.addAttribute( 'normal', new Float32Array( normals ), 3 );
        lineMesh.geometry.addAttribute( 'color', new Float32Array( colors ), 3 );
        lineMesh.geometry.addAttribute( 'uv', new Float32Array( uvs ), 2 );
        lineMesh.geometry.addAttribute( 'lineIndex', new Float32Array( lineIndices ), 1 );
        lineMesh.geometry.addAttribute( 'segmentIndex', new Float32Array( segmentIndices ), 1 );
        lineMesh.geometry.addAttribute( 'lineSpeed', new Float32Array( lineSpeeds ), 1 );
        lineMesh.geometry.addAttribute( 'vertexIndex', new Float32Array( verticeIndices ), 1 );



        lineMesh.material = new Program(renderer.gl,{
            vertexShader:   LineVS,
            fragmentShader: LineFS,
            type: renderer.gl.POINTS,
            depthTest: false,
            blend: true,
            blendSrcRGB:   renderer.gl.SRC_ALPHA,
            blendDstRGB:   renderer.gl.ONE_MINUS_SRC_ALPHA,
            blendSrcAlpha: renderer.gl.ONE,
            blendDstAlpha: renderer.gl.ONE,
        });
        
        lineMesh.material.name = 'lineMesh.material';

        // debugData.cache.programs[ lineMesh.material.name ] = lineMesh.material
        // lineMesh.static = true;

        this.lineMesh  = lineMesh;
        this.useTarget = false;

    }
    
    update() {



        ///////// TIMER ////////////
        let newTime =  ( typeof performance === 'undefined' ? Date : performance ).now();
        let diff = ( newTime - lastDate ) / 100;
    
        diff = Math.min(30, diff)
    
        lastDate = newTime;
        elapsed += diff
    
        uniforms.uMinExpandRatio      = settings.uMinExpandRatio;
        uniforms.uMaxExpandRatio      = settings.uMaxExpandRatio;
        uniforms.uNumGroups           = settings.uNumGroups;
        uniforms.uFollowSphereSurface = settings.uFollowSphereSurface;
        uniforms.uLineGlobalAlpha     = settings.uLineGlobalAlpha;
        uniforms.uLightColor          = lightColor;
        uniforms.active               = 1
        uniforms.uExposition          = 1
        uniforms.uNormalScale         = [0.25,0.25];
        uniforms.timer                = elapsed;
        uniforms.delta                = diff;
    

        colorProgess += 0.05;
        
        let p = ((colorProgess)  / LINE_START_COLORS.length) % LINE_START_COLORS.length;
        let startColorIndex = Math.floor( p );
        
        let r = p - startColorIndex;
        let nextColorIndex  = startColorIndex + 1;
        nextColorIndex  = nextColorIndex > LINE_START_COLORS.length-1 ? 0  :  nextColorIndex
        
        uniforms.uLineStartColor = uniforms.uLineStartColor || []
        uniforms.uLineEndColor   = uniforms.uLineEndColor || []
        uniforms.uLineStartColor[0] = 1//LINE_START_COLORS[startColorIndex][0] * (1. - r) + r * LINE_START_COLORS[nextColorIndex][0];
        uniforms.uLineStartColor[1] = 1//LINE_START_COLORS[startColorIndex][1] * (1. - r) + r * LINE_START_COLORS[nextColorIndex][1];
        uniforms.uLineStartColor[2] = 1//LINE_START_COLORS[startColorIndex][2] * (1. - r) + r * LINE_START_COLORS[nextColorIndex][2];
        uniforms.uLineEndColor[0]   = 1//LINE_END_COLORS[startColorIndex][0] * (1. - r)  + r *  LINE_END_COLORS[nextColorIndex][0];
        uniforms.uLineEndColor[1]   = 1//LINE_END_COLORS[startColorIndex][1] * (1. - r)  + r *  LINE_END_COLORS[nextColorIndex][1];
        uniforms.uLineEndColor[2]   = 1//LINE_END_COLORS[startColorIndex][2] * (1. - r)  + r *  LINE_END_COLORS[nextColorIndex][2];
        
        uniforms.spread    = settings.spread;
        uniforms.factor    = settings.factor;
        uniforms.uSegments = LINE_SEGMENTS;
        uniforms.uSegmentLength = settings.uSegmentLength
        uniforms.uLifeSpeed = settings.lineLifeSpeed
        uniforms.evolution = settings.evolution;
        uniforms.rotation  = settings.rotation;
        uniforms.radius    = settings.radius
        uniforms.speed     = settings.speed;

        setUniform(lineMesh.material.uniforms, 'spread', uniforms.spread)
        setUniform(lineMesh.material.uniforms, 'factor', uniforms.factor)
        setUniform(lineMesh.material.uniforms, 'uSegments', uniforms.uSegments)
        setUniform(lineMesh.material.uniforms, 'uLifeSpeed', uniforms.uLifeSpeed)
        setUniform(lineMesh.material.uniforms, 'evolution', uniforms.evolution)
        setUniform(lineMesh.material.uniforms, 'rotation', uniforms.rotation)
        setUniform(lineMesh.material.uniforms, 'radius', uniforms.radius)
        setUniform(lineMesh.material.uniforms, 'speed', uniforms.speed)
        setUniform(lineMesh.material.uniforms, 'uLineEndColor', uniforms.uLineEndColor)
        setUniform(lineMesh.material.uniforms, 'uLineStartColor', uniforms.uLineStartColor)
        setUniform(lineMesh.material.uniforms, 'uMinExpandRatio', uniforms.uMinExpandRatio)
        setUniform(lineMesh.material.uniforms, 'uMaxExpandRatio', uniforms.uMaxExpandRatio)
        setUniform(lineMesh.material.uniforms, 'uNumGroups', uniforms.uNumGroups)
        setUniform(lineMesh.material.uniforms, 'uFollowSphereSurface', uniforms.uFollowSphereSurface)
        setUniform(lineMesh.material.uniforms, 'uLineGlobalAlpha', uniforms.uLineGlobalAlpha)
        setUniform(lineMesh.material.uniforms, 'uLightColor', uniforms.uLightColor)
        setUniform(lineMesh.material.uniforms, 'timer', uniforms.timer)
        setUniform(lineMesh.material.uniforms, 'delta', uniforms.delta)
        setUniform(lineMesh.material.uniforms, 'uNormalScale', uniforms.uNormalScale)

        // if (settings.useAddBlending) {
        //     lineMesh.material.blendSrcRGB   = renderer.gl.SRC_ALPHA
        //     lineMesh.material.blendDstRGB   = renderer.gl.ONE
        //     lineMesh.material.blendSrcAlpha = renderer.gl.ONE
        //     lineMesh.material.blendDstAlpha = renderer.gl.ONE
        // }
        // else {
        //     lineMesh.material.blendSrcRGB   = renderer.gl.SRC_ALPHA
        //     lineMesh.material.blendDstRGB   = renderer.gl.ONE_MINUS_SRC_ALPHA
        //     lineMesh.material.blendSrcAlpha = renderer.gl.ONE
        //     lineMesh.material.blendDstAlpha = renderer.gl.ONE
        // }

        setUniform(linePositionMaterial.uniforms, 'spread', uniforms.spread)
        setUniform(linePositionMaterial.uniforms, 'factor', uniforms.factor)
        setUniform(linePositionMaterial.uniforms, 'uSegments', uniforms.uSegments)
        setUniform(linePositionMaterial.uniforms, 'uLifeSpeed', uniforms.uLifeSpeed)
        setUniform(linePositionMaterial.uniforms, 'evolution', uniforms.evolution)
        setUniform(linePositionMaterial.uniforms, 'rotation', uniforms.rotation)
        setUniform(linePositionMaterial.uniforms, 'radius', uniforms.radius)
        setUniform(linePositionMaterial.uniforms, 'speed', uniforms.speed)
        setUniform(linePositionMaterial.uniforms, 'uLineEndColor', uniforms.uLineEndColor)
        setUniform(linePositionMaterial.uniforms, 'uLineStartColor', uniforms.uLineStartColor)
        setUniform(linePositionMaterial.uniforms, 'uMinExpandRatio', uniforms.uMinExpandRatio)
        setUniform(linePositionMaterial.uniforms, 'uMaxExpandRatio', uniforms.uMaxExpandRatio)
        setUniform(linePositionMaterial.uniforms, 'uNumGroups', uniforms.uNumGroups)
        setUniform(linePositionMaterial.uniforms, 'uFollowSphereSurface', uniforms.uFollowSphereSurface)
        setUniform(linePositionMaterial.uniforms, 'uLineGlobalAlpha', uniforms.uLineGlobalAlpha)
        setUniform(linePositionMaterial.uniforms, 'uLightColor', uniforms.uLightColor)
        setUniform(linePositionMaterial.uniforms, 'timer', uniforms.timer)
        setUniform(linePositionMaterial.uniforms, 'delta', uniforms.delta)
        setUniform(linePositionMaterial.uniforms, 'uNormalScale', uniforms.uNormalScale)
        setUniform(linePositionMaterial.uniforms, 'useTarget', this.useTarget ? 1 : 0)

        renderer.clear();
        renderer.clearColor(0.,0.,0.,0.);
        bufferPlane.material = linePositionMaterial

  
        
        setUniform(linePositionMaterial.uniforms, 'oPosition',   lineSimulationTexture)
        setUniform(linePositionMaterial.uniforms, 'tTarget',   targetTexture)
        setUniform(linePositionMaterial.uniforms, 'uParticleResolution', LINE_BUFFER_SIZE)
        setUniform(linePositionMaterial.uniforms, 'uParticleLifeSpeed', settings.lineLifeSpeed)

        setUniform(lineMesh.material.uniforms, 'uParticleResolution', LINE_BUFFER_SIZE)
        setUniform(lineMesh.material.uniforms, 'uParticleLifeSpeed', settings.lineLifeSpeed)
        setUniform(lineMesh.material.uniforms, 'uResolution', [window.innerWidth, window.innerHeight])



        // if (linePositionMaterial.uniforms.tPosition) {
        //     linePositionMaterial.uniforms.tPosition.value = linePositionRead;
        // }
        setUniform(lineMesh.material.uniforms, 'tPosition',   targetTexture)


        // if (this.options.profile == 0) {
        //     linePositionRead = targetTexture;
        //     setUniform(lineMesh.material.uniforms, 'tPosition',   targetTexture)
        //     setUniform(lineMesh.material.uniforms, 'oPosition',   targetTexture)
        //     setUniform(lineMesh.material.uniforms, 'tTarget',     targetTexture)
        //     return
        // }


        bufferPlane.scale[0] = LINE_BUFFER_SIZE[0]
        bufferPlane.scale[1] = LINE_BUFFER_SIZE[1]
        bufferCamera.left    =  -LINE_BUFFER_SIZE[0]/2
        bufferCamera.right   =   LINE_BUFFER_SIZE[0]/2
        bufferCamera.top     =   LINE_BUFFER_SIZE[1]/2
        bufferCamera.bottom  = -LINE_BUFFER_SIZE[1]/2
        bufferCamera.updateProjectionMatrix()
        bufferCamera.update()
        renderer.render(bufferScene, bufferCamera, linePositionWrite);

        debugData.renderPasses.push({ name: 'GPGPULinesPositionRenderPass', material: linePositionMaterial,  buffer: linePositionWrite })

        // swap buffers
        if (hasRenderedOnce) {
            let wLine = linePositionWrite
            linePositionWrite = linePositionRead;
            linePositionRead = wLine;
        }
        else {
            linePositionWrite = linePositionBack;
            linePositionRead = linePositionFront;
            hasRenderedOnce = true;
        }

    }

}
